import { createSelector } from "reselect"
import { get, sumBy } from "lodash"
import { getForecast, getPortfolioRisk, getPortfolioEquity, getBenchmarkReturn } from "modules/optimization/selectors/data"
import { safeDivide } from "helpers/math"
import { findEquitySize } from "../helpers"

const EMPTY_ARRAY = []
const EMPTY_OBJECT = {}
export const getOptimizationRisk = state => get(state, "global.data.scorecardData.data.model.optimization.risk[0]", EMPTY_ARRAY)
const getOptimizedPositions = state => get(state, "global.data.scorecardData.data.model.optimization.positions.dates[0]")

export const getRebalancedForecast = createSelector(
  [getOptimizationRisk, getForecast, getOptimizedPositions, getPortfolioEquity, getBenchmarkReturn],
  (summary, forecast, optimizedPositions, portfolioEquity, benchmarkReturn) => {
    if (optimizedPositions) {
      const total = get(summary, "total", 0)
      const returnPercEquities = sumBy(get(forecast, "equities", EMPTY_ARRAY), equity => {
        const size = findEquitySize(equity, optimizedPositions)
        return Number.isFinite(size) ? equity.expectedPercentReturn * safeDivide(size, portfolioEquity) : 0
      })

      const returnPercSwaps = sumBy(get(forecast, "swaps", EMPTY_ARRAY), swap => {
        const size = findEquitySize(swap, optimizedPositions)
        return Number.isFinite(size) ? swap.expectedPercentReturn * safeDivide(size, portfolioEquity) : 0
      })

      const returnPerc = returnPercEquities + returnPercSwaps - benchmarkReturn

      return ({
        returnPerc,
        total,
        sharpe: safeDivide(returnPerc, total * 100),
      })
    }

    return EMPTY_OBJECT
  },
)

export const getOriginalRiskDecomposition = createSelector(
  [getPortfolioRisk],
  (summary) => ({
    specific: get(summary, "attribution.summary.specific", 0),
    factorsTotal: get(summary, "attribution.summary.factors", 0),
  }),
)

export const getRebalancedRiskDecomposition = createSelector(
  [getOptimizationRisk],
  (summary) => ({
    specific: get(summary, "attribution.summary.specific", 0),
    factorsTotal: get(summary, "attribution.summary.factors", 0),
  }),
)
